import SignOut from './sign_out';
import withPGTranslation from '../../../config/withPGTranslation';

export default withPGTranslation(SignOut);
